export const linkClass = "text-gray-700 transition-colors duration-200 transform rounded-md hover:bg-blue-200";
export const titleClass = "font-semibold text-gray-800";
export const sectionClass = "pb-10";
export const boldListClass = "padding-ul list-disc list-outside font-semibold";
export const listClass = "padding-ul list-outside";
export const mainSection = "w-full max-w-4xl px-6 py-4 mx-auto bg-white rounded-md shadow-md  my-3";
export const pageTitle = "text-3xl font-semibold text-center text-gray-800";
